import React from 'react'
import { FormattedMessage } from 'react-intl'

import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'
import { WebinarPanelComponent } from '../../../sharedLegacy/features/WebinarSidebarFeature/components'
import ButtonComponent from '../../../sharedLegacy/components/ButtonComponent/ButtonComponent'

import './JoinToSpeakNotSupportedPanel.scss'

type Props = {
  onDismiss: () => void
}

const JoinToSpeakNotSupportedPanel = ({ onDismiss }: Props) => {
  const webinarColors = useWebinarColors()

  return (
    <WebinarPanelComponent className="join-to-speak-not-supported-panel">
      <header>
        <FormattedMessage defaultMessage="Thanks for your interest to use OnCamera" />
      </header>
      <div className="info">
        <p>
          <FormattedMessage defaultMessage="To join the speakers on video we require you to use a more advanced browser such as Google Chrome or Microsoft Edge." />
        </p>
        <p>
          <FormattedMessage defaultMessage="In the mean time you can ask questions in the usual way through the sidebar on the right." />
        </p>
      </div>
      <ButtonComponent
        className="cancel-button"
        type="button"
        color="themed"
        style={{
          color: webinarColors.tabs.contrast.color,
          backgroundColor: webinarColors.tabs.contrast.transparent('5%'),
        }}
        round
        ariaLabel="Acknowledge message"
        onClick={onDismiss}
      >
        <FormattedMessage defaultMessage="I understand" />
      </ButtonComponent>
    </WebinarPanelComponent>
  )
}

export default JoinToSpeakNotSupportedPanel
